import { useSelector } from 'react-redux';
import Commons from '../Services/Common/Common';
import Global from '../Services/Common/Global';

/**
 * 공통 코드 조회 (SP_GetCode) → 알림 코드 필요
 * FCM 발송 함수
 * @param {Object} fcmSendData
 * @param {string} fcmSendData.targetUserId   - 수신자 ID
 * @param {string} fcmSendData.requestUserId  - 발신자 ID
 * @param {string} fcmSendData.body           - 알림 본문 내용
 * @param {string} fcmSendData.status         - 알림 상태 (코드명 매칭에 사용)
 * @param {string} fcmSendData.codeGroup      - 코드 그룹 (ex: 'AL_002' 작업허가서, 'AL_006' 작업중지)
 * @param {string} fcmSendData.title          - 알림 제목
 * @param {string} fcmSendData.route          - 앱에서 이동할 경로
 * @param {string} fcmSendData.responseData   - 추가 데이터 (ex: PM_CD, WORK_STOP_CD)
 */

const useFcmHandler = () => {
  const { userInfo } = useSelector((state) => state.BaseInfo);

  // const [codeList, setCodeList] = useState({});

  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const result = await Commons.Axios(
  //         'post',
  //         Global.base.useUrl + Global.urls.Execute.execute,
  //         [{ procedureName: 'SP_GetCode' }]
  //       );
  //       const data = result.data;
  //       if (!data || data.length === 0) return;
  //       if (data[0]?.type === 'Error') throw new Error(data[0].message);

  //       const grouped = {};
  //       data.forEach((item) => {
  //         if (!grouped[item.groupCd]) grouped[item.groupCd] = [];
  //         grouped[item.groupCd].push(item);
  //       });
  //       setCodeList(grouped);
  //     } catch (e) {
  //       console.error(e);
  //     }
  //   })();
  // }, []);

  const sendFcm = async ({
    targetUserId,
    body,
    codeGroup,
    title,
    route,
    responseData,
  }) => {
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.FCM.fcm,
        [
          {
            ResponseId: Commons.EncryptAES(targetUserId),
            Title: Commons.EncryptAES(title),
            Body: Commons.EncryptAES(body),
            FcmToken: Commons.EncryptAES(''),
            Gubun: Commons.EncryptAES(codeGroup),
            RequestId: userInfo.userid,
            Route: Commons.EncryptAES(route),
            ResponseData: Commons.EncryptAES(String(responseData ?? '')),
          },
        ]
      );

      const data = result.data;

      if (data && data.length > 0) {
        if (data[0].type === 'Error') {
          throw new Error(data[0].message);
        } else if (data === 'Fail') {
          console.log('⚠️ 해당 사용자가 로그인하지 않았습니다.');
        } else {
          console.log('✅ 알림 전송 완료:', title, body);
        }
      }
    } catch (error) {
      console.error('❌ sendFcm error:', error);
    }
  };

  return sendFcm;
};

export default useFcmHandler;
